import useTypedTranslation, {
  type TFunctionType,
} from "@/core/hooks/use-typed-translation";

/**
 * Traductions des écrans transactions (clés `wallet.transactions.*`).
 *
 * Les clés vivent dans le fragment `features/wallet/i18n/transactions.json`
 * et seront fusionnées dans `src/locales/*.json` lors du câblage final :
 * tant que la fusion n'est pas faite, `TFunctionType` (dérivé de fr.json)
 * ne les connaît pas encore, d'où le cast.
 */
export const useTransactionsTranslation = () => {
  const { t } = useTypedTranslation();
  return { t: (key: string) => t(key as TFunctionType) };
};
